var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"cabinet-page-header"},[_c('div',[(_vm.eyebrow)?_c('span',[_vm._v(_vm._s(_vm.eyebrow))]):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }